<template>
  <p class="font-weight-regular text--disabled">
    <span class="red--text text--lighten-1">*</span> {{ $t('common.requiredFields') }}
  </p>
</template>

<script>
export default {
  name: 'RequiredExplained'
}
</script>
